module.exports = __webpack_public_path__ + "static/img/3areaA_6.ff15cd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/3areaA_6.png
// module id = 863
// module chunks = 1